import React, { useState, useEffect } from "react";
import { Modal, Input, message } from "antd";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import dotenv from 'dotenv';
dotenv.config();

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;
const { REACT_APP_RAPOR_PASS } = process.env;

function Rapor() {
  const [kullaniciVeri, setkullaniciVeri] = useState([]);
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const today = new Date();
  const formattedDate = format(today, 'dd/MM/yyyy');
  console.log(formattedDate); // Output: e.g. 22/09/2021

  const handleOk = async () => {
    if (password === REACT_APP_RAPOR_PASS) {
      setIsAuthenticated(true);
    } else {
      message.error("Invalid password. Please try again.");
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchVeri();
    }
  }, [isAuthenticated]);

  const fetchVeri = async () => {
    try {
      const response = await fetch(`${REACT_APP_SUPABASE_URL}/rest/v1/kullanici_veri?limit=10000`, {
        method: "GET",
        headers: {
          apikey: REACT_APP_SUPABASE_KEY,
        }
      });
      const data = await response.json();
      setkullaniciVeri(data);
      // Print length of data
      console.log(data.length);
      downloadExcel(data);
    } catch (error) {
      // handle error here...
    }
  };

  // const fetchVeri = async () => {
  //   try {
  //     let allData = [];
  //     let page = 1;
  //     const limit = 1000; // Number of rows to fetch per request
  
  //     while (true) {
  //       const response = await fetch(
  //         `${REACT_APP_SUPABASE_URL}/rest/v1/kullanici_veri?limit=10000`,
  //         {
  //           method: "GET",
  //           headers: {
  //             apikey: REACT_APP_SUPABASE_KEY,
  //           },
  //         }
  //       );
  
  //       const data = await response.json();
  //       allData = allData.concat(data);
  
  //       if (data.length < limit) {
  //         // If the response contains less than the limit, it means we've reached the end
  //         break;
  //       }
  
  //       page++;
  //     }
  
  //     setkullaniciVeri(allData);
  //     // Print length of data
  //     console.log(allData.length);
  //     downloadExcel(allData);
  //   } catch (error) {
  //     // handle error here...
  //   }
  // };
  

  const downloadExcel = (data) => {
    try {
      const transformedData = data.map(item => {
        // Start with 'tarih' and include other keys except 'id' and 'created_at'
        const newItem = {
          tarih: item.created_at ? format(new Date(item.created_at), 'dd/MM/yyyy') : '',
          ...Object.keys(item).reduce((obj, key) => {
            if (key !== 'created_at' && key !== 'id') {
              obj[key] = item[key];
            }
            return obj;
          }, {}),
        };
        return newItem;
      });
  
      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const dataBlob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
      
      
      saveAs(dataBlob, `tis_kullanici_rapor_${formattedDate}.xlsx`);
      message.success("Rapor Dosyası İndirildi!");
    } catch (error) {
      message.error("An error occurred while downloading Excel");
    }
  };
  
  

  return (
    <Modal title="Şifre" visible={!isAuthenticated} onOk={handleOk} onCancel={handleOk}>
      <Input.Password placeholder="Şifre Giriniz" value={password} onChange={e => setPassword(e.target.value)} />
    </Modal>
  );
}

export default Rapor;
